//全局变量
const state = {
        //loading...
        loading: false,
		}
    //改变变量只能通过方法执行改变
const mutations = {
    //同步方法
    LOADING_OPEN_CLOSE: (state, loading) => {
        state.loading = loading
    },
}
const actions = {
    // 异步执行调用方法,commit代表同步的方法提交,dispatch代表异步的方法提交
    // resolve返回的值,这个值就是方法运行结束后,所返回的值,可以是对象,也可以是变量
    // 异步方法需要按顺序执行时,或者需要当方法运行结束后需要干什么的时候,用到promise,方法后then调用后续函数
    loading_open_or_close({
        commit,
        state
    }, loading) {
        return new Promise(resolve => {
            commit('LOADING_OPEN_CLOSE', loading)
            resolve(state.loading)
        })

    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/Loading.js